import * as React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";

import {
  StyledBannerContainer,
  StyledBannerText,
  StyledBannerTextBold,
} from "../lib/styles";
import { DeactivatedBannerPropTypes } from "../lib/types";

import Button from "../../../reusable/button";
import styled from "styled-components";
import { redesignTheme } from "../../../theme/theme";
import ReactivateModal from "./reactivateModal";

const whiteExclamationCircle = require("../../../svg/whiteExclamationCircle.svg");

const StyledImg = styled.img`
  margin-right: ${redesignTheme.spacing[2.5]};
`;

const StyledButton = styled(Button)`
  height: 40px;
  text-wrap: nowrap;
`;

const StyledButtonWrapper = styled.div`
  margin-left: ${redesignTheme.spacing[2.5]};
  display: flex;
  align-items: center;
`;

const DeactivatedBanner = ({
  cardType,
  companyBlocklisted,
  companyId,
  hasPaymentMethod,
  last4,
  openPortal,
  setRefetchData,
  subscriptionType,
  updateToastMessage,
  userCount,
  modal,
  setModal,
}: DeactivatedBannerPropTypes): React.ReactElement => {
  const closeModal = (): void => {
    return setModal("");
  };

  return (
    <StyledBannerContainer data-testid="deactivated-banner">
      <div style={{ display: "flex" }}>
        <StyledImg src={whiteExclamationCircle} />
        <div>
          <StyledBannerTextBold>
            {hasPaymentMethod
              ? i18n.translate("admin_pages.settings.banner.deactivated_title")
              : i18n.translate(
                  "admin_pages.settings.banner.deactivated_title_no_cc"
                )}
          </StyledBannerTextBold>
          <StyledBannerText>
            {hasPaymentMethod
              ? i18n.translate("admin_pages.settings.banner.reactivate_info")
              : i18n.translate("admin_pages.settings.banner.no_payment_method")}
          </StyledBannerText>
        </div>
      </div>
      {!companyBlocklisted && (
        <StyledButtonWrapper>
          {hasPaymentMethod ? (
            <StyledButton
              onClick={(): void => {
                window.amplitude?.track("Reactivate Modal Opened");
                setModal("reactivate");
              }}
              size="small"
              testId="reactivate-button"
              variant="primaryInverse"
            >
              {i18n.translate("admin_pages.settings.banner.reactivate")}
            </StyledButton>
          ) : (
            <StyledButton
              onClick={(event): void => {
                window.amplitude?.track("Add Credit Card Modal Opened");
                return openPortal(event, "PAYMENT_SOURCES", () =>
                  setRefetchData(true)
                );
              }}
              size="small"
              testId="add-credit-card-button"
              variant="primaryInverse"
            >
              {i18n.translate("admin_pages.settings.banner.add_credit_card")}
            </StyledButton>
          )}
        </StyledButtonWrapper>
      )}
      <ReactivateModal
        last4={last4}
        cardType={cardType}
        closeModal={closeModal}
        companyId={companyId}
        fetchData={() => setRefetchData(true)}
        modal={modal}
        subscriptionType={subscriptionType}
        userCount={userCount}
        updateToastMessage={updateToastMessage}
      />
    </StyledBannerContainer>
  );
};

export default DeactivatedBanner;
